var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleCheckGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2.96368,
  y: 11.4551,
  width: 10.8799,
  height: 1.5009,
  transform: "rotate(-51 2.96368 11.4551)",
  fill: "grey"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.12354,
  y: 12.3936,
  width: 5.306,
  height: 1.5,
  transform: "rotate(-141 4.12354 12.3936)",
  fill: "grey"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 7.48041,
  y: 11.4551,
  width: 10.8799,
  height: 1.5009,
  transform: "rotate(-51 7.48041 11.4551)",
  fill: "grey"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.64026,
  y: 12.3936,
  width: 2.74671,
  height: 1.5,
  transform: "rotate(-141 8.64026 12.3936)",
  fill: "grey"
})));
export { SvgDoubleCheckGrey as ReactComponent };
export default __webpack_public_path__ + "a81c0c3d8e0ccc17b16cf9f8d757b92d.svg";